define('widgets/dataList/viewmodel',['plugins/widget', 'durandal/composition', 'jquery', 'knockout', 'services/trace', 'models/event', 'widgets/dataList/model'],
function (widget, composition, $, ko, trace, event, model) {
	var ctor = function () { };

	ctor.prototype.columns = function() {
		return this.settings.columnDefinitions;
	};

	ctor.prototype.fullSelectionState = ko.computed(function() {
		return false;
	});

	ctor.prototype.activate = function (settings) {
		var that = this;

		this.settings = settings;
		this.createColumnDefinitions(settings);

		// selected all checkBox
		this.fullSelectionState = ko.computed(function () {
			if (settings.controller === undefined) return false;

			var dataCount = settings.controller.result().length;
			var selectedItemsCount = this.getSelectedItems().length;

			return selectedItemsCount == dataCount;
		}, this);


		// auto scroll
		// => activate: <script src="Scripts/jquery.infinitescroll.min.js"></script>

		//var element = $('.dataGrid');
		//element.scroll(function() {
		//	var scrolltrigger = 0.80; // 0.95;
		//	var scrollTop = element.scrollTop();
		//	var documentHeight = $(document).height();
		//	var gridHeight = element.height();

		//	console.log('scrolltop:' + scrollTop);
		//	console.log('gridheight:' + gridHeight);
		//	console.log('documentheight:' + documentHeight);

		//	console.log(scrollTop / (documentHeight - gridHeight));

		//	if ((scrollTop / (documentHeight - gridHeight)) > scrolltrigger) {
		//	//	warn("done");
		//	}
		//});

	};

	ctor.prototype.attached = function (settings) {
		var that = this;

		// refresh => clear selectedItems
		if (this.refreshEvent == null) {
			this.refreshEvent = new event.EventHandler(function (sender, e) {
				var items = that.settings.selectedItems;
				if (items != null) {
					items.removeAll();
				}
			});

			this.settings.controller.onLoaded.add(this.refreshEvent);
		}
	}

	ctor.prototype.detached = function(settings) {
		if (this.refreshEvent != null) {
			this.settings.controller.onLoaded.remove(this.refreshEvent);
		}
	}

	ctor.prototype.sort = function (column) {
		var operator = column.sortDirection();

		this.clearSort();

		switch(operator) {
			case '':
				column.sortDirection('asc');
				break;
			case 'asc':
				column.sortDirection('desc');
				//this.controller().sortBy({ column: column.name, operator: column.sortDirection() });
				break;
			case 'desc':
				column.sortDirection('');
				break;
		}

		var controller = this.controller();
		var definition = controller.buildSort(column.name, column.sortDirection());
		controller.sortDefinitions.modify(function (s) {
			s.clear();
			if (column.sortDirection() !== '') {
				s.add(definition);
			}
		});

		return Q.when(controller.load());
	};

	ctor.prototype.setSelection = function() {
		var value = !this.fullSelectionState();
		var controller = this.settings.controller;
		var data = controller.result();

		if (this.settings.selectedItems === undefined) {
			setTimeout(function () {
				Enumerable.From(data)
					.ForEach(function (d) {
						d.isSelected = value;
					});
			});
		} else {
			var selectedItems = this.settings.selectedItems;
			setTimeout(function () {
				selectedItems.removeAll();
				if (value) {
					Enumerable.From(data)
						.ForEach(function (d) {
							selectedItems.push(d);
						});
				}
			});
		}
	};

	ctor.prototype.controller = function () {
		return this.settings.controller;
	};

	ctor.prototype.createColumnDefinitions = function(settings) {
		var definitions = [];

		settings.columns.forEach(function(element) {
			var column = new model.GridColumn();

			column.headerText = element.headerText;
			column.i18n = element.i18n;
			column.name = column.rowValue = element.name;

			if (element.rowValue !== undefined) column.rowValue = element.rowValue;
			if (element.sortable !== undefined) column.sortable = element.sortable;
			if (element.template !== undefined) column.template = element.template;
			if (element.canSelectAll !== undefined) column.canSelectAll = element.canSelectAll;
			if (element.sort !== undefined) column.sortDirection(element.sort);
			if (element.width !== undefined) column.width = element.width;


			definitions.push(column);
		});

		this.settings.columnDefinitions = definitions;
	};

	ctor.prototype.clearSort = function() {
		this.settings.columnDefinitions.forEach(function(element) {
			element.sortDirection('');
		});
	};




	ctor.prototype.getSelectedItems = function () {
		if (this.settings.selectedItems === undefined) {
			return Enumerable.From(this.settings.controller.result())
				.Where(function(d) { return d.isSelected == true; })
				.ToArray();
		} else {
			return this.settings.selectedItems();
		}
	}



	return ctor;
});


//{ headerText: '#', rowValue: 'isSelected', sortable: false, width: '30px', template: 'checkboxTemplate' },
//{ headerText: 'Email', rowValue: 'from', sortable: false, width: '175px', template: '' },
//{ headerText: 'Betreff', rowValue: 'subject', sortable: true, width: 'auto', template: 'subjectTemplate' },
//{ headerText: 'Erhalten am', rowValue: function(item) { return moment(item.receivedOn()).format('DD.MM.YYYY HH:mm') }, sortable: true, width: '150px', template: '' }

;
